
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../services/auth-guard/auth.guard';
import { MenuComponent } from './menu.component';

const routes: Routes = [
  {
    path: "",
    component: MenuComponent,
    children: [
      {
        path: "",
        redirectTo: "report",
        pathMatch: "full",
        canActivate: [AuthGuard],
      },
      {
        path: 'my-profile',
        loadChildren: () => import("./my-profile/my-profile.module").then(m => m.MyProfileModule)
      },
      {
        path: "report",
        loadChildren: () => import("./report/report-routing.module").then(m => m.ReportModule),
      },
      {
        path: "channel",
        loadChildren: () => import("./channel/channel-routing.module").then(m => m.ChannelModule)
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuRoutingModule { }
